import { render, staticRenderFns } from "./IP_ByQMReadmission.vue?vue&type=template&id=599a6517&scoped=true&"
import script from "./IP_ByQMReadmission.vue?vue&type=script&lang=js&"
export * from "./IP_ByQMReadmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599a6517",
  null
  
)

export default component.exports